export default __webpack_public_path__ + "static/media/vertices.f3e736a9.svg";